/*
 * Category Carousel — analytics wiring
 *
 * Emits two dataLayer events for the mobile category carousel:
 *
 *   category_carousel_viewed
 *     Trigger:  wrapper enters the viewport (IntersectionObserver, threshold 0.5)
 *     Payload:  {}
 *
 *   category_carousel_clicked
 *     Trigger:  click on a category link
 *     Payload:  { category_name, category_position }
 *
 * Runs once on DOM ready — no GrowthBook dependency.
 */

const setupCategoryCarouselTracking = () => {
  const wrappers = document.querySelectorAll('[data-category-carousel-tracker]');

  if ('IntersectionObserver' in window && wrappers.length) {
    const seen = new WeakSet();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !seen.has(entry.target)) {
          seen.add(entry.target);
          document.dispatchEvent(new CustomEvent('category_carousel_viewed', { bubbles: true }));
          if (window.dataLayer) {
            window.dataLayer.push({ event: 'category_carousel_viewed' });
          }
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    wrappers.forEach((w) => io.observe(w));
  }

  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-tracking-event="category_carousel_clicked"]');
    if (!link) return;
    const detail = {
      category_name: link.dataset.categoryName,
      category_position: Number(link.dataset.categoryPosition),
    };
    document.dispatchEvent(new CustomEvent('category_carousel_clicked', { detail, bubbles: true }));
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'category_carousel_clicked', ...detail });
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupCategoryCarouselTracking);
} else {
  setupCategoryCarouselTracking();
}
